module.exports = __webpack_public_path__ + "static/media/ehealth_health_coins_redemption_banner_mobile.6f96a4f3.jpg";